import { ButtonGroup } from "react-bootstrap";
import ApproveToolbox from "./approval/approveToolbox";
import Button from "@edaz/edazkit/Button/index";
import React from "react";
import type { ColumnDefinition } from "@frui.ts/dataviews";
import type ApprovalListViewModel from "viewModels/common/approvalListViewModel";
import type { ScreenBase } from "@frui.ts/screens/dist";
import ApprovalStatusColumn from "./approval/approvalStatusColumn";
import { isValidForApproval } from "utils/approvable";
import type { IApprovable } from "entities/types";

export function ApprovalColumns<
  TModel extends IApprovable<any>,
  TViewModel extends ApprovalListViewModel<any, TModel, ScreenBase, any>
>(vm: TViewModel, detailEnabled: boolean | undefined = true): ColumnDefinition<TModel>[] {
  const onItemClick = vm.onItemClick();

  return [
    ApprovalStatusColumn<TModel>(vm.approvedByApprover, vm.approvalType),
    {
      cellClassName: "sticky",
      headerClassName: "sticky",
      valueFormatter: ({ item }: { item: TModel }) => (
        <ButtonGroup className="d-flex justify-content-end">
          {isValidForApproval(item) && (
            <ApproveToolbox<TModel>
              approval={item}
              translate={vm.translateModuleGeneral}
              approve={vm.approveClick}
              canApprove={vm.canApprove}
              myApprovalStep={vm.myApprovalStep}
              approvedByMe={vm.approvedByMe}
              isExported={vm.isExported}
              disabled={!vm.allowApprove}
              buttonsStyle="rounded mx-1 my-1 btn-sm"
              rejectionReason={item.permittedActions?.approval.rejectionReason}
            />
          )}
          {detailEnabled && (
            <Button className="rounded my-1 mx-1" variant="success" size="sm" onClick={onItemClick && (() => onItemClick(item))}>
              {vm.translate("detail")}
            </Button>
          )}
        </ButtonGroup>
      ),
    },
  ];
}
